import React, { useContext } from "react";
import { SelectedCardContext } from "../../Context/SelectedCardContext";
import styles from "./ProcurementShipping.module.css";
import truck from "../../Assests/Images/truck.png";
import laptop from "../../Assests/Images/laptop.png";
import { useNavigate } from "react-router-dom";

import ship from "../../Assests/Images/sheep.png";
import arrow from "../../Assests/Images/purple Arrow.svg";
import truckIcon from "../../Assests/Images/truckicon.svg";
import badgeIcon from "../../Assests/Images/badgeicon.svg";
import userIcon from "../../Assests/Images/usericon.svg";
import networkIcon from "../../Assests/Images/network.png";
import CustomProcurementSupport from "./CustomProcurementSupport";
import ProcurementSupport from "../About/ProcurementSupport";
import ProcurementOptions from "./ProcurementOptions"; // Import the existing ProcurementOptions component
import SolutionsGrid from "./SolutionGrid/SolutionsGrid";
import Timeline from "./timeline.tsx"; // Import the Timeline component
export default function ProcurementShipping() {
    const navigate = useNavigate();
    const { selectedCard, setSelectedCard } = useContext(SelectedCardContext);
    
    const handleContactClick = () => {
        navigate("/contact");
    };
    
    const procurementData = [
        {
            title: "Seamless Global Procurement & Logistics Solutions",
            description: "Streamlined global procurement and logistics services that ensure efficient supply chain operations across international borders.",
            image: truck
        },
        {
            title: "Procurement Excellence",
            description: "Strategic sourcing and procurement expertise that delivers cost-effective solutions while maintaining quality and compliance standards.",
            image: laptop
        },
        {
            title: "Global Shipping Expertise",
            description: "Specialized shipping solutions for complex logistics challenges, ensuring timely delivery of goods to any destination worldwide.",
            image: ship
        }
    ];
    
    const getOtherCards = () => {
        if (!selectedCard) return [];
        return procurementData.filter(card => card.title !== selectedCard.title);
    };
    
    const handleReadMoreClick = (item) => {
        setSelectedCard(item);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    
    return (
        <div className={selectedCard ? styles.containerNopadding : styles.container}>
        {selectedCard ? (
            <>
                <CustomProcurementSupport />
                <ProcurementOptions otherProcurementOptions={getOtherCards()} />
            </>
        ) : (
                <>
                    <div className={styles.section1}>
                        {/* <div className={styles.left}>
                            <img src={truck} className={styles.imagetruck} />

                            <div className={styles.rightdescription}>
                                <h1 className={styles.lefttitle}>Seamless Global Procurement & Logistics Solutions</h1>
                            </div>

                            <div className={styles.readMoreContainer} onClick={() => handleReadMoreClick(procurementData[0])}>
                                <img src={arrow} className={styles.arrowIcon} alt="Arrow icon" />
                                <span className={styles.readmore}>Read More</span>
                            </div>
                            <div className={styles.laptop}>
                                <img src={laptop} className={styles.imagelaptop} />
                            </div>

                            <div className={styles.rightdescription}>
                                <h1 className={styles.lefttitle}>Procurement Excellence </h1>
                            </div>

                            <div className={styles.readMoreContainer} onClick={() => handleReadMoreClick(procurementData[1])}>
                                <img src={arrow} className={styles.arrowIcon} alt="Arrow icon" />
                                <span className={styles.readmore}>Read More</span>
                            </div>
                        </div>
                        <div className={styles.mainright}>
                            <div className={styles.right}>
                                <img src={ship} className={styles.image} />
                            </div>

                            <div className={styles.rightdescription}>
                                <h1 className={styles.righttitle}>Global Shipping Expertise </h1>
                            </div>

                            <div className={styles.readMoreContainer} onClick={() => handleReadMoreClick(procurementData[2])}>
                                <img src={arrow} className={styles.arrowIcon} alt="Arrow icon" />
                                <span className={styles.readmore}>Read More</span>
                            </div>
                        </div> */}
                        <SolutionsGrid/>
                    </div>
                    {/* <div className={styles.section2}>
                        <h1 className={styles.heading2}>Why Partner with Hyproc International?</h1>

                        <div className={styles.wrapper}>
                            <div className={styles.step}>
                                <div className={styles.circle}>
                                    <img src={truckIcon} alt="Truck" />
                                </div>
                                <div className={styles.line}></div>
                                <div className={styles.stepText}>
                                    <h3>End-to-End Supply Chain Expertise</h3>
                                    <p>Procurement, logistics, and compliance all in one place.</p>
                                </div>
                            </div>

                            <div className={styles.step}>
                                <div className={styles.circle}>
                                    <img src={badgeIcon} alt="Badge" />
                                </div>
                                <div className={styles.line}></div>
                                <div className={styles.stepText}>
                                    <h3>Proven Reliability</h3>
                                    <p>Decades of experience delivering results across industries.</p>
                                </div>
                            </div>

                            <div className={styles.step}>
                                <div className={styles.circle}>
                                    <img src={userIcon} alt="User" />
                                </div>
                                <div className={styles.stepText}>
                                    <h3>Client-First Approach</h3>
                                    <p>Personalized service with a dedicated account manager.</p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div>
                        <Timeline />
                    </div>

                    <div className={styles.globalPartnerSection}>
                        <div className={styles.globalPartnerContainer}>
                            <div className={styles.globalSection}>
                                <div className={styles.globalContent}>
                                    <h2 className={styles.globalHeading}>
                                        Let's Optimize Your Supply Chain
                                    </h2>
                                    <p className={styles.globalText}>
                                        Looking for a procurement and logistics partner you can trust?{" "}
                                        <br />
                                        <span onClick={handleContactClick} className={styles.contactLink}>Contact Us </span>
                                        today to discuss your shipping and supply needs.
                                    </p>
                                </div>
                                <div className={styles.globalImageWrapper}>
                                    <img
                                        src={networkIcon}
                                        alt="Global Partner"
                                        className={styles.globalImage}
                                        style={{ borderRadius: "20px" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}